module.exports = __webpack_public_path__ + "466e035e27ca52547a07cc3ba70b80eb.png";